/**
 * Sidebar Nav mobile dropdown — navigation handler.
 *
 * blocks/sidebar-nav.liquid renders a custom-select component inside
 * a `.sidebar-nav__mobile` wrapper at ≤767px. Each option's value is
 * the link URL; this module listens for the snippet's
 * `custom-select:change` event (bubbles from
 * <custom-select-component>) and navigates to the selected URL.
 *
 * Document-level listener handles every sidebar-nav on the page at
 * once (e.g. a sticky one + a non-sticky one). The `.closest()` check
 * confines the navigation behaviour to sidebar-nav selects so it
 * doesn't hijack any other custom-select on the page (form fields,
 * shipping country pickers, etc.).
 */
document.addEventListener('custom-select:change', (event) => {
  const target = event.target;
  if (!(target instanceof Element)) return;

  // Bail if this select isn't the sidebar-nav mobile dropdown.
  if (!target.closest('.sidebar-nav__mobile')) return;

  const url = event.detail?.value;
  if (!url || typeof url !== 'string') return;

  // No-op when the user reselects the page they're already on — avoids
  // a reload loop if the current page is in the menu and someone taps it.
  try {
    const target_url = new URL(url, window.location.href);
    if (target_url.pathname === window.location.pathname && target_url.search === window.location.search) {
      return;
    }
    window.location.assign(target_url.href);
  } catch {
    // Relative or malformed URLs land here — fall back to a raw assign.
    if (url !== window.location.pathname) window.location.assign(url);
  }
});
